import { makeConnectedControllers } from '../connectedControllers/connectedControllers'
import { makeControllerInput } from '@merels/input/controllerInput'
import type { InputDep } from './input.types'
import type { ControllerInput, ControllerInputDeps } from '@merels/input/controllerInput'

/**
 * `controllerInput`, if provided, is used as-is instead of building one via
 * `makeControllerInput` — a headless Node client injects a test-controllable
 * implementation here (see apps/web/tests/step_definitions_headless), since
 * the real one drives its keyboard/gamepad listeners off browser globals
 * that don't exist in Node.
 */
export function makeInput(deps?: { controllerInputDeps?: ControllerInputDeps; controllerInput?: ControllerInput }): InputDep {
  const controllerInput = deps?.controllerInput ?? makeControllerInput(deps?.controllerInputDeps)
  const connectedControllers = makeConnectedControllers({ controllerInput })

  return { controllerInput, connectedControllers }
}


